import React from 'react';
import { Navigate } from 'react-router-dom';
import { isSuperAdminSession } from './opsNav';

/**
 * 최고관리자 전용 화면 감싸개. 아니면 관제센터로 돌려보낸다.
 *
 * ⚠️ 이것만으로는 막히지 않는다. localStorage 는 브라우저에 있고 고쳐 쓸 수 있다.
 *    실제 차단은 서버의 src/server/adminScope/gate.js (SUPER_ADMIN_ONLY_ROUTES) 가 한다.
 *    여기서 하는 일은 "메뉴에 없는 화면을 주소로 열었을 때 빈 화면과 오류 배너 대신
 *    제자리로 돌려보내는 것"이다.
 */
export default function SuperAdminRoute({ children }) {
    if (!isSuperAdminSession()) return <Navigate replace to="/ControlCenter" />;
    return children;
}
